<template>
  <div>
    <div class="menu">
      <swipe class="swipe-menu" @change="(i) => (menucurrent = i)">
        <swipe-item
          v-for="(item, index) in Math.ceil(menu.length / 8)"
          :key="index"
        >
          <div class="swipe-menu-items">
            <template v-for="(it, i) in menu">
              <div
                :key="i"
                v-if="i >= index * 8 && i < (index + 1) * 8"
                @click="
                  $router.push({ path: '/teacherList', query: { id: it.id } })
                "
              >
                <img :src="it.icon" alt="" />
                <p>{{ it.title }}</p>
              </div>
            </template>
          </div>
        </swipe-item>
        <template #indicator v-if="menu.length > 8">
          <div class="custom-indicator">
            <div
              v-for="(item, index) in Math.ceil(menu.length / 8)"
              :key="index"
              :class="[
                index == menucurrent
                  ? 'custom-indicator-item-action'
                  : 'custom-indicator-item',
              ]"
            ></div>
          </div>
        </template>
      </swipe>
      <div class="want-btn" @click="$router.push('/ask')">我要提问</div>
    </div>

    <div class="modular">
      <div class="teacher">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>老师排行榜</div>
          </div>
          <div class="look-more" @click="$router.push('teacherTop')">
            <span>查看更多</span>
            <i class="iconfont icon-a-LeftArrow"></i>
          </div>
        </div>
        <div class="ls-top">
          <div class="top-img">
            <img src="../../assets/zx/top.png" alt="" />
          </div>
          <top :list="teacherList" />
        </div>
      </div>

      <div class="comment">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>热门评价</div>
          </div>
        </div>
        <div class="comment">
          <comment :list="pjList" :state="true" :zxshow="true" />
        </div>

        <div class="more" v-if="onmore">暂无更多</div>
        <div class="more" @click="lookmore" v-else>
          <small>查看更多</small>
          <!-- <img src="../../assets/zx/more.png" alt="" /> -->
          <i class="iconfont icon-gengduo1"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:
@createTime:2021-08-12
@create:wq
*/
import { Swipe, SwipeItem } from "vant";
import comment from "../../components/comment.vue";
import top from "../zx/teacherTop/componentTop.vue";
import { shareJsSdk} from "@/utils/tool";
export default {
  name: "zx",
  props: {},
  components: { Swipe, SwipeItem, comment, top },
  data() {
    return {
      menucurrent: 0,
      menu: [],
      teacherList: [],
      pjList: [],
      pjPage: 1,
      onmore: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.MSGNUM= 2;
    shareJsSdk('zx','可以测','国学传统文化 在线一对一咨询平台')
    this.getMenu();
    this.teacherRanking();
    this.popularReviews();
    this.msgPageNum()
    
  },
  methods: {
    msgPageNum(){
      this.api.msgPageNum().then(res => {
        this.$store.dispatch("app/setNum", res.data.msgPageNum);
      })
    },
    getMenu() {
      this.api.consultList().then((res) => {
        this.menu = res.data;
      });
    },
    teacherRanking() {
      this.api.teacherRanking().then((res) => {
        this.teacherList = res.data.data;
      });
    },
    popularReviews() {
      this.api.popularReviews({ page: this.pjPage }).then((res) => {
        this.pjList = [...this.pjList, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.onmore = true;
        }
      });
    },
    lookmore() {
      this.pjPage++;
      this.popularReviews();
    },
  },
};
</script>
<style lang="scss" scoped>
.swipe-menu {
  // height: 4.7rem;
  margin-top: 9px;
  .swipe-menu-items {
    min-height: 4rem;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    > div {
      width: calc(100% / 4);
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 13px;

      font-size: 0.24rem;
      font-weight: 400;
      color: #666666;

      img {
        width: 1.2rem;
        height: 1.2rem;
        box-shadow: 0px 6px 12px rgba(253, 248, 229, 0.2);
        margin-bottom: 3px;
        // border-radius: 10px;
      }
    }
  }
  .custom-indicator {
    bottom: 0px;
  }
}
.custom-indicator {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  .custom-indicator-item {
    width: 8px;
    height: 8px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    margin-right: 8px;
  }
  .custom-indicator-item-action {
    width: 16px;
    height: 8px;
    background: #4fd9d5;
    border-radius: 4px;
    margin-right: 8px;
  }
}
.want-btn {
  margin: 0.43rem 0.24rem 0.7rem;
  background-color: #4fd9d5;
  border-radius: 0.54rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.3rem;
  height: 0.88rem;
}
.modular {
  margin: 0 0.24rem;

  .modular-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      font-size: 0.32rem;
      font-weight: bold;
      color: #333333;
      display: flex;
      align-items: center;
      .title-line {
        width: 4px;
        height: 16px;
        background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
        opacity: 1;
        border-radius: 0px 4px 4px 0px;
        margin-right: 6px;
      }
    }
    .look-more {
      font-size: 0.22rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 6px;
      }
      i {
        font-size: 0.2rem;
      }
    }
  }

  .teacher {
    .ls-top {
      margin-top: 7px;
      padding: 10px;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      .top-img {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .ls-i {
        height: 1.8rem;
        border-bottom: 1px solid #f0f0f0;
        padding: 0.26rem 0;
        display: flex;
        align-items: center;
        &:last-child {
          border-bottom: none;
        }
        .top-n {
          flex-shrink: 0;
          width: 0.54rem;
          margin-right: 0.2rem;
          img {
            width: 100%;
          }
        }
        .top-n-n {
          flex-shrink: 0;
          width: 0.54rem;
          height: 0.54rem;
          margin-right: 0.2rem;
          background: #f0f0f0;
          border: 1px solid #e6e6e6;
          border-radius: 50%;
          font-size: 0.3rem;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ls-img {
          flex-shrink: 0;
          width: 1.28rem;
          height: 1.28rem;
          border: 2px solid #ffffff;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 0.1rem;

          img {
            width: 100%;
          }
        }
        .ls-con {
          flex: 1;

          .ls-name {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .lable {
            display: flex;
            flex-wrap: wrap;
            margin-top: 4px;
            > div {
              padding: 2px 8px;
              height: 0.36rem;
              background: #ffeedf;
              border-radius: 0.22rem;

              font-size: 0.2rem;
              font-weight: 400;
              line-height: 40px;
              color: #ffa380;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 0.1rem;
              margin-top: 2px;
            }
          }
        }
        .ls-aw-num {
          flex-shrink: 0;
          font-size: 0.2rem;
          font-weight: bold;
          color: #cccccc;
          white-space: nowrap;
          span {
            font-size: 0.3rem;
            color: #999999;
          }
        }
      }
    }
  }
  .comment {
    margin-top: 0.36rem;

    .more {
      font-size: 12px;
      font-weight: 500;
      color: #666666;
      text-align: center;
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        display: inline-block;
        width: 0.22rem;
        margin-left: 3px;
      }
      i {
        font-size: 0.22rem;
        color: #3dc3bf;
        margin-left: 3px;
      }
    }
  }
}
</style>
